var _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatActive = function SvgChatActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M3 12a9 9 0 1 1 4.876 8.001l-3.618.965a1 1 0 0 1-1.228-1.209l.928-3.712A8.966 8.966 0 0 1 3 12Zm9 6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#3B7CC9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    clipPath: "url(#chat-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.725 12.396a5.143 5.143 0 1 1-5.143-5.143m-5.143 5.143h5.934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.582 7.253a8.878 8.878 0 0 0-1.978 5.143 8.877 8.877 0 0 0 1.978 5.143 8.878 8.878 0 0 0 1.836-3.956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.347 9.403c-.3-.052-.3-.484 0-.536a2.723 2.723 0 0 0 2.193-2.1l.017-.083c.066-.298.489-.3.557-.003l.022.097a2.737 2.737 0 0 0 2.2 2.087c.3.052.3.487 0 .54a2.737 2.737 0 0 0-2.2 2.087l-.022.096c-.068.297-.49.295-.557-.002l-.017-.083a2.722 2.722 0 0 0-2.193-2.1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat-active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
};
export default SvgChatActive;